// src/services/passwordReset.js
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";

export const resetAdminPassword = async (email) => {
  try {
    if (!email) {
      throw new Error("Email missing");
    }

    await sendPasswordResetEmail(auth, email);

    return true;
  } catch (err) {
    console.error("Password reset failed:", err);
    throw new Error(
      err?.message || "Failed to send password reset email"
    );
  }
};
